import {
  del,
  get,
  patch,
  type RequestConfig,
  axiosConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/tiffin-seva-admin`;
const SILENT: RequestConfig = { showNotification: false };

class TiffinSevaAdminService {
  listInquiriesPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<any>> => {
    return fetchListPage<any>(`${BASE}/`, query);
  };

  getInquiry = async (id: number): Promise<any | undefined> => {
    const data = await get<ApiItemResponse<any> | any>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  createInquiry = async (payload: FormData): Promise<any | undefined> => {
    const response = await axiosConfig.post<any>(`${BASE}/`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return unwrapItem(response.data);
  };

  updateInquiry = async (
    id: number,
    payload: Partial<any>
  ): Promise<any | undefined> => {
    const data = await patch<any, Partial<any>>(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  deleteInquiry = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };

  approveInquiry = async (id: number): Promise<any | undefined> => {
    const data = await patch<any, null>(
      `${BASE}/${id}/approve/`,
      null,
      SILENT
    );
    return unwrapItem(data);
  };

  rejectInquiry = async (id: number): Promise<any | undefined> => {
    const data = await patch<any, null>(
      `${BASE}/${id}/reject/`,
      null,
      SILENT
    );
    return unwrapItem(data);
  };

  getDashboard = async (): Promise<any | undefined> => {
    const data = await get<any>(
      `${BASE}/dashboard/`,
      SILENT
    );
    return unwrapItem(data);
  };
}

export const tiffinSevaAdminService = new TiffinSevaAdminService();
